<template src="./PrivacyPolicy.template.html"></template>

<script setup>
import { useI18n } from 'vue-i18n'
import LayoutMain from '../components/ui/LayoutMain.vue'
import PageHeader from '../components/ui/PageHeader.vue'

const { t } = useI18n()
</script>

<style scoped>
/* Add any component-specific styles here if needed */
/* Tailwind handles most of the styling, but you can add custom ones */
</style>
